export const ENOVIA_OLD_LINK_PATTERN = 'enovia_'
export const ENOVIA_NEW_LINK_PATTERN = 'enovia-object:'
export const ENOVIA_GROUP_STATUS_NAME = 'ds6w_47_ds6w_58_what_47_ds6w_58_status'
